import { PATHOLOGY_AI_RESULTS } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getPathologyAIResults = createAsyncThunk(
  'getPathologyAIResults',
  async (payload: { hospitalId: string; wsiId: string }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(`${PATHOLOGY_AI_RESULTS}/${payload.hospitalId}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ wsiId: payload.wsiId }),
      });
      return await response.json();
    } catch (error) {
      return error;
    }
  }
);

export default getPathologyAIResults;
